import { StackChildren } from '@doordash/design-language'
import * as React from 'react'
import LegalText from '../../atoms/legal-text'

import { backgroundCheckDisclosure } from './strings'

export const BackgroundCheckDisclosure: React.SFC = () => (
  <StackChildren>
    <LegalText>{backgroundCheckDisclosure.text1()}</LegalText>
    <LegalText>{backgroundCheckDisclosure.text2()}</LegalText>
  </StackChildren>
)

export default BackgroundCheckDisclosure
